export const STALE_5_MIN    = 1000 * 60 * 5
export const STALE_1_HOUR   = 1000 * 60 * 60
export const STALE_7_DAYS   = 1000 * 60 * 60 * 24 * 7
export const GC_10_MIN      = 1000 * 60 * 10
export const GC_30_MIN      = 1000 * 60 * 30
export const GC_4_HOURS     = 1000 * 60 * 60 * 4
export const GC_14_DAYS     = 1000 * 60 * 60 * 24 * 14

export const DEFAULT_RANKINGS_LIMIT = 100
export const MIN_COVERAGE_THRESHOLD = 0.7
export const DEFAULT_TIME_SERIES_LIMIT = 12
export const MIN_SEARCH_QUERY_LENGTH = 2
